import React from 'react';
import Loader from 'react-loader-spinner';
import withTranslations from '../../utils/HighOrderComponent';

const LoadingIndicator = (props) => {
  const { syncSignal, t } = props;
  return (
    <div
      style={{
        width: '100%',
        height: '100',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loader
        type="Oval"
        color="#a9454f"
        height="500"
        width="100"
        justify-content="center"
        align-items="center"
      />
      {syncSignal && (
        <div>
          <p className="text-center">{t.syncKjsMessage}</p>
          <p className="text-center">{t.syncKjsAdditionalMessage}</p>
        </div>
      )}
    </div>
  );
};

export default withTranslations(LoadingIndicator, 'LoadingIndicator');
